import loggerLocal from '@/utils/loggerLocal'


import { useStoreUser } from './storeUser'
// auth.js


import { router, routesName } from '@/plugins/router'

import { type Auth, getAuth, signInWithEmailAndPassword, signOut, type User } from 'firebase/auth'

import { useFirebaseAuth } from 'vuefire'
import type { IntAuthorization } from '@functions/models/interfaces/intAuthorization'
import type { IntCredentials } from '@functions/models/interfaces/intCredentials'
import { showErrorMessage } from '@/utils/showMessage'
//import { Message, MessageType, useStoreMessage } from './storeMessage';

//const storeMessage=useStoreMessage();
//const auth = initializeFirebase().auth

export const useStoreAuth = defineStore( 'storeAuth', {
    state: () => ( {
        user: {} as User,
        authorization: [] as IntAuthorization[],
        isLoggedIn: false,
        isUpdated: false,
    } ),
    getters: {
        getIsLoggedIn: state => state.user && state.user !== null && state.user !== undefined,
        getUserId: state => state.user?.uid as string,
    },
    actions: {
        setStoreUser ( user: User ) {
            this.user = user
            if ( user )
            {
                this.isLoggedIn = true
                this.isUpdated = true
            }
        },
        setStoreAuthorization ( authorization: IntAuthorization[] ) {
            this.authorization = authorization
        },
        async getUserData () {
            const auth = getAuth()
            const user = auth.currentUser
            if ( user )
            {
                this.user = user
                this.isLoggedIn = true
                this.isUpdated = true
            } else
            {
                this.user = {} as User
                this.isLoggedIn = false
            }
        },


        signIn ( credentials: IntCredentials ) {
            const auth = useFirebaseAuth()
            signInWithEmailAndPassword( auth as Auth, credentials.email, credentials.password )
                .then( userCredential => {
                    // Signed in
                    const user = userCredential.user
                    //console.log('Sign-in', user)
                    loggerLocal.info( 'Sign-in', user )
                    // ...
                } )
                .catch( error => {
                    const errorCode = error.code
                    const errorMessage = error.message
                    //console.log('error', error)
                    loggerLocal.error( 'error', error )
                    showErrorMessage( errorMessage )
                    /*
          const err: Message={
              type: MessageType.error,
              techInfo: error.Message,
              code: error.code,
              text: 'Errore'
            }
            storeMessage.showMessage(err)
            */
                } )
        },
        async signOut () {
            try
            {
                const auth = getAuth()
                await signOut( auth as Auth )
                    .then( () => {
                        loggerLocal.info( 'User Signed out' ) // Sign-out successful.
                        return true
                    } )
                    .catch( error => {
                        loggerLocal.error( 'error', error )
                        return false
                    } )
            } catch ( err )
            {
                loggerLocal.error( 'error signout', err )
            }
            await router.push( routesName.login )
            this.isLoggedIn = false
            this.authorization = []
            const storeUser = useStoreUser()

            storeUser.userCompanyData = {}
            storeUser.userData = {}
            storeUser.companyData = {}
        },
    },
} )

// make sure to pass the right store definition, `useAuth` in this case.
/*if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useStoreAuth, import.meta.hot))
}*/
